import * as React from 'react';
const SvgChevronLeftOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M8.229 13.209a.75.75 0 0 1 .007-1.086l7.492-7.245a.75.75 0 1 1 1.042 1.079l-6.867 6.64a.1.1 0 0 0 0 .144l6.867 6.635a.75.75 0 0 1-1.042 1.079l-7.493-7.24"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgChevronLeftOutlined;
